import { theme } from '@/theme/theme'
import { useCallback, useLayoutEffect, useState } from 'react'
import { isMobile as deviceIsMobile } from 'react-device-detect'

type WindowSize = {
  width: number
  height: number
}

export const useIsMobile = (
  breakpoint?: keyof typeof theme.breakpoints.values,
) => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: 0,
    height: 0,
  })

  const handleSize = useCallback(() => {
    const width = window.innerWidth
    const height = window.innerHeight

    setWindowSize((prev) => {
      if (prev.width === width && prev.height === height) return prev
      return { width, height }
    })
  }, [])

  useLayoutEffect(() => {
    handleSize()
    window.addEventListener('resize', handleSize)
    return () => window.removeEventListener('resize', handleSize)
  }, [handleSize])

  const breakpointValue = breakpoint
    ? theme.breakpoints.values[breakpoint]
    : 769

  return {
    mobileDevice: deviceIsMobile,
    isMobile: windowSize.width < breakpointValue,
    width: windowSize.width,
    height: windowSize.height,
    isLandscape: window.matchMedia('(orientation: landscape)').matches,
    windowSize,
  }
}
